import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b442edf4")

_pushScopeId("data-v-b442edf4")
const _hoisted_1 = {
  action: "",
  autocomplete: "off"
}
const _hoisted_2 = { class: "divide-elements" }
const _hoisted_3 = { class: "element-first" }
const _hoisted_4 = { class: "data second alert-message" }
const _hoisted_5 = { class: "input-border first" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "title" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Interní název", -1)
const _hoisted_8 = { class: "group" }
const _hoisted_9 = { class: "border-gr short" }
const _hoisted_10 = { class: "end-form" }
const _hoisted_11 = { class: "list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheLanguage = _resolveComponent("TheLanguage")
  const _component_TheFaq = _resolveComponent("TheFaq")
  const _component_TheFaqList = _resolveComponent("TheFaqList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("form", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_TheLanguage, {
            "selected-languages": _ctx.languages,
            name: "lang",
            title: "Jazyková mutace",
            onAddLanguage: _ctx.addNewFaq
          }, null, 8, ["selected-languages", "onAddLanguage"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _withDirectives(_createVNode("input", {
                type: "text",
                autocomplete: "nope",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.faqTitle = $event))
              }, null, 512), [
                [_vModelText, _ctx.faqTitle]
              ])
            ])
          ])
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.faqTranslates, (faq) => {
        return (_openBlock(), _createBlock(_component_TheFaq, {
          key: faq,
          faq: faq,
          onSetImageContent: _ctx.setImageContent,
          onSetPageContent: _ctx.setPageContent,
          onSetTitle: _ctx.setTitle
        }, null, 8, ["faq", "onSetImageContent", "onSetPageContent", "onSetTitle"]))
      }), 128)),
      _createVNode("div", _hoisted_10, [
        (_ctx.isRearranging)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "convert",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveOrderedFaqs && _ctx.saveOrderedFaqs(...args)))
            }, "Save"))
          : _createCommentVNode("", true),
        (_ctx.isRearranging)
          ? (_openBlock(), _createBlock("button", {
              key: 1,
              class: "convert",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelRearrange && _ctx.cancelRearrange(...args)))
            }, "Cancel"))
          : _createCommentVNode("", true),
        (!_ctx.isRearranging)
          ? (_openBlock(), _createBlock("button", {
              key: 2,
              class: "convert",
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rearrange && _ctx.rearrange(...args)))
            }, "Rearrange"))
          : _createCommentVNode("", true),
        _createVNode("button", {
          class: "convert",
          type: "button",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveFaq && _ctx.saveFaq(...args)))
        }, "Zveřejnit")
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_TheFaqList, {
        faqs: _ctx.getSortedArray,
        "is-rearranging": _ctx.isRearranging,
        onMoveFaq: _ctx.moveFaq,
        onRefreshFaqs: _ctx.refreshFaqs,
        onStartLoading: _ctx.startLoading,
        onEditFaq: _ctx.editFaq,
        onInvokeError: _ctx.invokeError,
        onInvokeSuccess: _ctx.invokeSuccess
      }, null, 8, ["faqs", "is-rearranging", "onMoveFaq", "onRefreshFaqs", "onStartLoading", "onEditFaq", "onInvokeError", "onInvokeSuccess"])
    ])
  ], 64))
})